var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.43597 5.18404C3 6.03969 3 7.15979 3 9.4V14.6C3 16.8402 3 17.9603 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C6.03969 21 7.15979 21 9.4 21H14.6C16.8402 21 17.9603 21 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C21 17.9603 21 16.8402 21 14.6V9.4C21 7.15979 21 6.03969 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C17.9603 3 16.8402 3 14.6 3H9.4C7.15979 3 6.03969 3 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404ZM8 8V13H16V8C16 8 14.4111 7.5 12 7.5C9.58886 7.5 8 8 8 8ZM14 15C14 15.552 14.448 16 15 16C15.552 16 16 15.552 16 15C16 14.448 15.552 14 15 14C14.448 14 14 14.448 14 15ZM8 15C8 15.552 8.448 16 9 16C9.552 16 10 15.552 10 15C10 14.448 9.552 14 9 14C8.448 14 8 14.448 8 15ZM12 6C15.6631 6 17 7.071 17 7.071V17C17 17.5523 16.5523 18 16 18H15L14.5 17H9.5L9 18H8C7.44772 18 7 17.5523 7 17V7.071C7 7.071 8.33693 6 12 6Z",
    fill: "#1A73F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusDark);
export default __webpack_public_path__ + "static/media/bus-dark.57cdffecf502354cead5aef29c1cf09e.svg";
export { ForwardRef as ReactComponent };